import * as actions from '..';

const billingReducerDefaultState = {
  alertDetails: {},
  error: {},
  nextInvoice: {},
  helpTooltipText: '',
  isAddPaymentDrawerOpen: false,
  isPaymentDrawerOpen: false,
  isLoading: false,
  globalWarning: '',
  locations: [],
  activeLocation: {},
  customError: '',
  isSummaryPage: false,
};

export const billingLandingReducer = (
  state = billingReducerDefaultState,
  action
) => {
  switch (action.type) {
    case actions.ADD_NEXT_INVOICE:
      return {
        ...state,
        nextInvoice: {
          ...action.payload,
        },
      };
    case actions.ADD_GLOBAL_ERROR:
      return {
        ...state,
        error: {
          ...action.payload,
        },
      };
    case actions.CLEAR_GLOBAL_ERROR:
      return {
        ...state,
        error: {},
      };
    case actions.SET_HEADER_TOOLTIP_TEXT:
      return {
        ...state,
        helpTooltipText: action.payload,
      };
    case actions.TOGGLE_CARD_DRAWER:
      return {
        ...state,
        isAddPaymentDrawerOpen: !state.isAddPaymentDrawerOpen,
      };
    case actions.TOGGLE_PAYMENT_DRAWER:
      return {
        ...state,
        isPaymentDrawerOpen: !state.isPaymentDrawerOpen,
      };
    case actions.START_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case actions.STOP_LOADING:
      return {
        ...state,
        isLoading: false,
      };
    case actions.ADD_GLOBAL_WARNING:
      return {
        ...state,
        globalWarning: action.payload,
      };
    case actions.CLEAR_GLOBAL_WARNING:
      return {
        ...state,
        globalWarning: '',
      };
    case actions.ADD_LOCATION_LIST:
      return {
        ...state,
        locations: [...action.payload],
      };
    case actions.ADD_BILL_TO_SITE_NUMBER:
      return {
        ...state,
        activeLocation: action.payload,
      };
    case actions.ADD_CUSTOM_ERROR:
      return {
        ...state,
        customError: action.payload,
      };
    case actions.CLEAR_CUSTOM_ERROR:
      return {
        ...state,
        customError: '',
      };
    case actions.ADD_ALERT_DETAILS:
      return {
        ...state,
        alertDetails: {
          ...action.payload,
          display: true,
        },
      };
    case actions.CLEAR_ALERT_DETAILS:
      return {
        ...state,
        alertDetails: {},
      };
    case actions.CLEAR_NEXT_INVOICE:
      return {
        ...state,
        nextInvoice: {},
      };
    case actions.SET_SUMMARY_PAGE_FLAG:
      return {
        ...state,
        isSummaryPage: action.payload,
      };
    default:
      return state;
  }
};
